/* eslint-disable */
// tslint:disable
/**
 * Chroma
 *
 *
 * OpenAPI spec version: 0.5.6.dev52
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

export namespace Api {
	export interface Add201Response {
	}

	export interface AddRequest {
		embeddings?: (Api.AddRequest.Embedding[]) | null;
		metadatas?: ((Api.AddRequest.Metadatum | null)[]) | null;
		documents?: ((string | null)[]) | null;
		uris?: ((string | null)[]) | null;
		ids: string[];
	}

	/**
	 * @export
	 * @namespace AddRequest
	 */
	export namespace AddRequest {
		export interface Embedding {
		}

		export interface Metadatum {
		}

	}

	export interface AddV1201Response {
	}

	export interface AddV1Request {
		embeddings?: (Api.AddV1Request.Embedding[]) | null;
		metadatas?: ((Api.AddV1Request.Metadatum | null)[]) | null;
		documents?: ((string | null)[]) | null;
		uris?: ((string | null)[]) | null;
		ids: string[];
	}

	/**
	 * @export
	 * @namespace AddV1Request
	 */
	export namespace AddV1Request {
		export interface Embedding {
		}

		export interface Metadatum {
		}

	}

	export interface ADelete200Response {
	}

	export interface ADeleteRequest {
		ids?: (string[]) | null;
		where?: Api.ADeleteRequest.Where | null;
		'where_document'?: Api.ADeleteRequest.WhereDocument | null;
	}

	/**
	 * @export
	 * @namespace ADeleteRequest
	 */
	export namespace ADeleteRequest {
		export interface Where {
		}

		export interface WhereDocument {
		}

	}

	export interface AGet200Response {
	}

	export interface AGetRequest {
		ids?: (string[]) | null;
		where?: Api.AGetRequest.Where | null;
		'where_document'?: Api.AGetRequest.WhereDocument | null;
		sort?: string | null;
		/**
		 * @type {number | null}
		 * @memberof AGetRequest
		 */
		limit?: number | null;
		/**
		 * @type {number | null}
		 * @memberof AGetRequest
		 */
		offset?: number | null;
		include?: Api.IncludeEnum[];
	}

	/**
	 * @export
	 * @namespace AGetRequest
	 */
	export namespace AGetRequest {
		export interface Where {
		}

		export interface WhereDocument {
		}

	}

	export interface Count200Response {
	}

	export interface CountCollections200Response {
	}

	export interface CountCollectionsV1200Response {
	}

	export interface CountV1200Response {
	}

	export interface CreateCollection200Response {
	}

	export interface CreateCollectionRequest {
		name: string;
		configuration?: Api.CreateCollectionRequest.Configuration | null;
		metadata?: Api.CreateCollectionRequest.Metadata | null;
		'get_or_create'?: boolean;
	}

	/**
	 * @export
	 * @namespace CreateCollectionRequest
	 */
	export namespace CreateCollectionRequest {
		export interface Configuration {
		}

		export interface Metadata {
		}

	}

	export interface CreateCollectionV1200Response {
	}

	export interface CreateCollectionV1Request {
		name: string;
		configuration?: Api.CreateCollectionV1Request.Configuration | null;
		metadata?: Api.CreateCollectionV1Request.Metadata | null;
		'get_or_create'?: boolean;
	}

	/**
	 * @export
	 * @namespace CreateCollectionV1Request
	 */
	export namespace CreateCollectionV1Request {
		export interface Configuration {
		}

		export interface Metadata {
		}

	}

	export interface CreateDatabase200Response {
	}

	export interface CreateDatabaseRequest {
		name: string;
	}

	export interface CreateDatabaseV1200Response {
	}

	export interface CreateDatabaseV1Request {
		name: string;
	}

	export interface CreateTenant200Response {
	}

	export interface CreateTenantRequest {
		name: string;
	}

	export interface CreateTenantV1200Response {
	}

	export interface CreateTenantV1Request {
		name: string;
	}

	export interface DeleteCollection200Response {
	}

	export interface DeleteCollectionV1200Response {
	}

	export interface DeleteDatabase200Response {
	}

	export interface DeleteV1200Response {
	}

	export interface DeleteV1Request {
		ids?: (string[]) | null;
		where?: Api.DeleteV1Request.Where | null;
		'where_document'?: Api.DeleteV1Request.WhereDocument | null;
	}

	/**
	 * @export
	 * @namespace DeleteV1Request
	 */
	export namespace DeleteV1Request {
		export interface Where {
		}

		export interface WhereDocument {
		}

	}

	export interface GetCollection200Response {
	}

	export interface GetCollectionV1200Response {
	}

	export interface GetDatabase200Response {
	}

	export interface GetDatabaseV1200Response {
	}

	export interface GetNearestNeighbors200Response {
	}

	export interface GetNearestNeighborsRequest {
		where?: Api.GetNearestNeighborsRequest.Where | null;
		'where_document'?: Api.GetNearestNeighborsRequest.WhereDocument | null;
		'query_embeddings': Api.GetNearestNeighborsRequest.QueryEmbedding[];
		/**
		 * @type {number}
		 * @memberof GetNearestNeighborsRequest
		 */
		'n_results'?: number;
		include?: Api.IncludeEnum[];
	}

	/**
	 * @export
	 * @namespace GetNearestNeighborsRequest
	 */
	export namespace GetNearestNeighborsRequest {
		export interface Where {
		}

		export interface WhereDocument {
		}

		export interface QueryEmbedding {
		}

	}

	export interface GetNearestNeighborsV1200Response {
	}

	export interface GetNearestNeighborsV1Request {
		where?: Api.GetNearestNeighborsV1Request.Where | null;
		'where_document'?: Api.GetNearestNeighborsV1Request.WhereDocument | null;
		'query_embeddings': Api.GetNearestNeighborsV1Request.QueryEmbedding[];
		/**
		 * @type {number}
		 * @memberof GetNearestNeighborsV1Request
		 */
		'n_results'?: number;
		include?: Api.IncludeEnum[];
	}

	/**
	 * @export
	 * @namespace GetNearestNeighborsV1Request
	 */
	export namespace GetNearestNeighborsV1Request {
		export interface Where {
		}

		export interface WhereDocument {
		}

		export interface QueryEmbedding {
		}

	}

	export interface GetTenant200Response {
	}

	export interface GetTenantV1200Response {
	}

	export interface GetUserIdentity200Response {
	}

	export interface GetV1200Response {
	}

	export interface GetV1Request {
		ids?: (string[]) | null;
		where?: Api.GetV1Request.Where | null;
		'where_document'?: Api.GetV1Request.WhereDocument | null;
		sort?: string | null;
		/**
		 * @type {number | null}
		 * @memberof GetV1Request
		 */
		limit?: number | null;
		/**
		 * @type {number | null}
		 * @memberof GetV1Request
		 */
		offset?: number | null;
		include?: Api.IncludeEnum[];
	}

	/**
	 * @export
	 * @namespace GetV1Request
	 */
	export namespace GetV1Request {
		export interface Where {
		}

		export interface WhereDocument {
		}

	}

	export interface HTTPValidationError {
		detail?: Api.ValidationError[];
	}

	export enum IncludeEnum {
		Documents = 'documents',
		Embeddings = 'embeddings',
		Metadatas = 'metadatas',
		Distances = 'distances',
		Uris = 'uris',
		Data = 'data'
	}

	export interface ListCollections200Response {
	}

	export interface ListCollectionsV1200Response {
	}

	export interface ListDatabases200Response {
	}

	export interface PreFlightChecks200Response {
	}

	export interface PreFlightChecks200Response2 {
	}

	export interface Update200Response {
	}

	export interface UpdateCollection200Response {
	}

	export interface UpdateCollectionRequest {
		'new_name'?: string | null;
		'new_metadata'?: Api.UpdateCollectionRequest.NewMetadata | null;
	}

	/**
	 * @export
	 * @namespace UpdateCollectionRequest
	 */
	export namespace UpdateCollectionRequest {
		export interface NewMetadata {
		}

	}

	export interface UpdateCollectionV1200Response {
	}

	export interface UpdateCollectionV1Request {
		'new_name'?: string | null;
		'new_metadata'?: Api.UpdateCollectionV1Request.NewMetadata | null;
	}

	/**
	 * @export
	 * @namespace UpdateCollectionV1Request
	 */
	export namespace UpdateCollectionV1Request {
		export interface NewMetadata {
		}

	}

	export interface UpdateRequest {
		embeddings?: (Api.UpdateRequest.Embedding[]) | null;
		metadatas?: ((Api.UpdateRequest.Metadatum | null)[]) | null;
		documents?: ((string | null)[]) | null;
		uris?: ((string | null)[]) | null;
		ids: string[];
	}

	/**
	 * @export
	 * @namespace UpdateRequest
	 */
	export namespace UpdateRequest {
		export interface Embedding {
		}

		export interface Metadatum {
		}

	}

	export interface UpdateV1200Response {
	}

	export interface UpdateV1Request {
		embeddings?: (Api.UpdateV1Request.Embedding[]) | null;
		metadatas?: ((Api.UpdateV1Request.Metadatum | null)[]) | null;
		documents?: ((string | null)[]) | null;
		uris?: ((string | null)[]) | null;
		ids: string[];
	}

	/**
	 * @export
	 * @namespace UpdateV1Request
	 */
	export namespace UpdateV1Request {
		export interface Embedding {
		}

		export interface Metadatum {
		}

	}

	export interface Upsert200Response {
	}

	export interface UpsertRequest {
		embeddings?: (Api.UpsertRequest.Embedding[]) | null;
		metadatas?: ((Api.UpsertRequest.Metadatum | null)[]) | null;
		documents?: ((string | null)[]) | null;
		uris?: ((string | null)[]) | null;
		ids: string[];
	}

	/**
	 * @export
	 * @namespace UpsertRequest
	 */
	export namespace UpsertRequest {
		export interface Embedding {
		}

		export interface Metadatum {
		}

	}

	export interface UpsertV1200Response {
	}

	export interface UpsertV1Request {
		embeddings?: (Api.UpsertV1Request.Embedding[]) | null;
		metadatas?: ((Api.UpsertV1Request.Metadatum | null)[]) | null;
		documents?: ((string | null)[]) | null;
		uris?: ((string | null)[]) | null;
		ids: string[];
	}

	/**
	 * @export
	 * @namespace UpsertV1Request
	 */
	export namespace UpsertV1Request {
		export interface Embedding {
		}

		export interface Metadatum {
		}

	}

	export interface ValidationError {
		loc: (string | number)[];
		msg: string;
		'type': string;
	}

}
